<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii"></a>
<h1 class="toc-title"><span class="bold">Contents</span></h1>
<div class="img_containerc"><img alt="images" src="images/common.jpg"/></div>
<h2 class="toc1"><a href="#/xhtml/05_Note"><span class="bold">Translator’s Note</span></a></h2>
<h2 class="toc1"><a href="#/xhtml/06_Foreword"><span class="bold">Foreword</span> <em class="italic">by Roger Moorhouse</em></a></h2>
<h2 class="toc1"><a href="#/xhtml/07_Preface"><span class="bold">Preface</span></a></h2>
<h2 class="toc"><a href="#/xhtml/08_Chapter01"><span class="tochang">CHAPTER 1</span> <span class="bold">Apprentice and Journeyman</span></a></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter02" title="Link target outside of Sample"><span class="tochang">CHAPTER 2</span> <span class="bold">At the Reich Labour Camp</span></span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample"><span class="tochang">CHAPTER 3</span> <span class="bold">How We Became Soldiers</span></span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample"><span class="tochang">CHAPTER 4</span> <span class="bold">On Sick Leave</span></span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample"><span class="tochang">CHAPTER 5</span> <span class="bold">To the Eastern Front</span></span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample"><span class="tochang">CHAPTER 6</span> <span class="bold">Rude Awakening</span></span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter07" title="Link target outside of Sample"><span class="tochang">CHAPTER 7</span> <span class="bold">Forced Labour by the Sea of Azov</span></span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter08" title="Link target outside of Sample"><span class="tochang">CHAPTER 8</span> <span class="bold">An Unknown Destination</span></span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter09" title="Link target outside of Sample"><span class="tochang">CHAPTER 9</span> <span class="bold">The Escape</span></span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter10" title="Link target outside of Sample"><span class="tochang">CHAPTER 10</span> <span class="bold">An Endless Expanse</span></span></h2>
<h2 class="toc"><span href="#/xhtml/18_Chapter11" title="Link target outside of Sample"><span class="tochang">CHAPTER 11</span> <span class="bold">Shattered Hopes</span></span></h2>
<h2 class="toc"><span href="#/xhtml/19_Chapter12" title="Link target outside of Sample"><span class="tochang">CHAPTER 12</span> <span class="bold">Contact with the Homeland</span></span></h2>
<h2 class="toc"><span href="#/xhtml/20_Chapter13" title="Link target outside of Sample"><span class="tochang">CHAPTER 13</span> <span class="bold">Returning Home</span></span></h2>
<h2 class="toc"><span href="#/xhtml/21_Chapter14" title="Link target outside of Sample"><span class="tochang">CHAPTER 14</span> <span class="bold">A Difficult Beginning</span></span></h2>
<a id="page_viii"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?48e70c18